import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AuthService} from 'src/app/core/services/auth.service';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {WarningButtonComponent} from '../../buttons/warning-button/warning-button.component';
import {DialogService} from 'src/app/core/services/dialog.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    WarningButtonComponent,
  ],
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent {
  @Input() logoutCallback?: Function;

  constructor(
    private authService: AuthService,
    private dialogService: DialogService
  ) {
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  onLogoutClick() {
    this.dialogService.confirm('Uscita', 'Eseguendo l\'uscita sarai reindirizzato alla schermata di accesso.', {
      label: 'Esci',
      color: 'warn',
      icon: 'logout',
      raised: true
    }).subscribe((result) => {
      if (result === true) {
        if (this.logoutCallback) {
          this.logoutCallback();
        }
        this.authService.logout();
      }
    })
  }
}
